import { createContext } from 'react'
import { ToastDataType, ToastOptions } from './toast.types'

export interface ToastContextType {
  toasts: ToastDataType[]
  toast: (options: ToastOptions) => void
  dismiss: (id: string) => void
  dismissAll: () => void
}

export const ToastContext = createContext<ToastContextType>({
  toasts: [],
  toast: () => {},
  dismiss: () => {},
  dismissAll: () => {},
})
